import React from 'react';

import { generatePath, useParams, useRouteMatch } from 'react-router-dom';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import useUserHook from 'hooks/useUserHook';

import FileUploader from 'components/common/FileUploader/fileUploader';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { DropdownMenu } from 'components/common/ProgramLibraryDropdownMenu/dropdownMenu';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';
import { useProjectTreeWithUrlHook } from 'components/common/TreeProgramFilter/ProjectTree/hooks/useProjectTreeWithUrlHook';
import { RenderUploadFilesModal } from 'components/common/UploadFileModal/RenderUploadFilesModal';
import { UploadVersionWarningModal } from 'components/common/UploadVersionWarningModal/uploadVersionWarningModal';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { Button } from 'components/DesignSystem/Button/Button';
import { TreeProgramTopHeader } from 'components/common';
import { UploadOpcModal } from 'components/pages/ProgramLibraryPage/components/UploadOpcModal/UploadOpcModal';
import LibraryTable from 'components/widgets/RenderLibraryTable/libraryTable';

export const ProgramLibraryPage = () => {
    const { opcEnabled } = useUserHook();
    const { setParams } = useProjectTreeWithUrlHook();
    const { path } = useRouteMatch();
    const { ability } = useUserHook();
    const { projectId, contractId } = useParams<{ projectId: string; contractId: string }>();
    useFullStoryPageView({ pageName: executionConfig.programLibrary.title });
    const url = new URL(window.location.href).origin + generatePath(path, { projectId, contractId });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader versionSelectorEnabled={false} showAll={true} callback={setParams}>
                            <ShareInsightButton
                                title={executionConfig.programLibrary.title}
                                link={url}
                                customTriggerElement={
                                    <Button variant={'secondary'} circle>
                                        <MuiIcon icon={'share'} color={'var(--button-tertiary-fg)'} />
                                    </Button>
                                }
                            />
                            {ability.can('view', 'ManageProjects') && <DropdownMenu callback={setParams} />}
                            {ability.can('view', 'UploadVersion') && <FileUploader />}
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={executionConfig.programLibrary.title}></ProgramTopHeader>
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <LibraryTable />
            </MainContent>

            <RenderUploadFilesModal />
            <UploadVersionWarningModal />
            {opcEnabled && <UploadOpcModal />}
        </PageContainer>
    );
};
